import { GetDepositPaymentInfoFuncParams } from "shared/functions/getDepositPaymentInfo";

import { IState } from "..";
import FirebaseFunctionsService from "../../../services/firebase/functions/FirebaseFunctionsService";
import RavenService from "../../../services/Logging/RavenService";
import { Dispatch } from "../../store/store";
import { IApplicationPaymentParams } from "./PaymentModule";
import { IApplication } from "shared/model/IApplication";
import MixPanelAnalyticsService from "src/services/Analytics/MixPanelAnalyticsService";

export const postMemberPayment = async (
  params: IApplicationPaymentParams,
  state: IState
) => {
  Dispatch.payment.postingMemberPayment();

  try {
    const { cardInfo, coworkName, application, businessName, applicantName } = params;
    const { applicantEmail, monthlyPaymentAmount} = application;
    if (
      !application.uid ||
      !applicantEmail ||
      !monthlyPaymentAmount ||
      !cardInfo
    ) {
      throw new Error(`Missing params`);
    }
    
    const response = await FirebaseFunctionsService.memberPayment({
      coworkName,
      applicationId: application.uid,
      applicantEmail,
      amount: monthlyPaymentAmount,
      cardInfo,
      businessName,
      applicantName
    });
    if (!response.ok) {
      const error = response.error
        ? (response.error.code as string)
        : response.message;
      throw new Error(error);
    }

    Dispatch.payment.memberPaymentSucceeded();
    trackPaymentSuccess(
      application,
      monthlyPaymentAmount,
      false,
      Boolean(cardInfo)
    );
  } catch (err) {
    const errorMessage = `Failed posting member payment ${err} `;
    const error: Error = err;
    Dispatch.payment.memberPaymentFailed(error.message);
    RavenService.captureMessage(errorMessage);
  }
};

export const fetchPaymentInfo = async (
  params: GetDepositPaymentInfoFuncParams,
  state: IState
) => {
  try {
    Dispatch.payment.fetchPaymentInfo(params);

    const response = await FirebaseFunctionsService.getDepositPaymentInfo(
      params
    );
    if (response.ok && response.data) {
      Dispatch.payment.fetchPaymentInfoSucceeded(response.data);
    } else {
      throw new Error(
        response.error ? response.error.message : response.message
      );
    }
  } catch (error) {
    const errorMessage = `Failed fetching payment info ${error} with ${JSON.stringify(
      params
    )}`;

    Dispatch.payment.fetchPaymentInfoFailed(error.message);
    RavenService.captureMessage(errorMessage);
  }
};

const trackPaymentSuccess = (
  application: IApplication,
  financingAmount: number,
  isACH: boolean,
  isCard: boolean
) => {
  MixPanelAnalyticsService.trackDepositCollectorSuccess(
    isACH,
    isCard,
    false,
    financingAmount || -1,
    application!
  );
};



// WEBPACK FOOTER //
// ./src/state/modules/payment/PaymentEffects.ts